module.exports = __webpack_public_path__ + "img/6.05c8bd89.png";